import { TTabOption } from '@ui/tabs/tabs.types';
import CoursesSettings from './content/courses/courses';
import LeaderboardSettings from './content/leaderboard';
import { ESettingsTypes, ESettingsTypesLabels } from './settings.types';
import SiteSettings from './content/site/site';
import AdvancedSettings from './content/advanced/advanced';
import Integrations from './content/integrations/integrations';
import RegistrationSettings from './content/registration/registration-settings';

export const SETTINGS_TABS: TTabOption[] = [
  { label: ESettingsTypesLabels.Site, value: ESettingsTypes.Site, content: <SiteSettings /> },
  { label: ESettingsTypesLabels.Registration, value: ESettingsTypes.Registration, content: <RegistrationSettings /> },
  { label: ESettingsTypesLabels.Advanced, value: ESettingsTypes.Advanced, content: <AdvancedSettings /> },
  { label: ESettingsTypesLabels.Courses, value: ESettingsTypes.Courses, content: <CoursesSettings /> },
  { label: ESettingsTypesLabels.Leaderboard, value: ESettingsTypes.Leaderboard, content: <LeaderboardSettings /> },
  { label: ESettingsTypesLabels.Integrations, value: ESettingsTypes.Integrations, content: <Integrations /> },
];
